/**
 * Position component - stores world position
 */

export interface PositionComponent {
  x: number;
  y: number;
  z: number;
}

export function createPosition(x: number = 0, y: number = 0, z: number = 0): PositionComponent {
  return { x, y, z };
}
